<template>
  <div class="container">
    <staffTable ></staffTable>
  </div>
</template>

<script>
import staffTable from './components/staffTable.vue'
export default {
  components:{
    staffTable,
  },
  data() {
    return {
        
    }
  },
  mounted(){
  },
  methods: {}

};
</script>

<style lang="less" scoped>
.container {
  // height: calc(100% - 20px);
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  .headerTask {
    margin-bottom: 15px;
  }
  .add,.search {
    background: #269d7b;
    color: #fff;
  }
  .search {
    border-radius: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/staff.vue